import {
  AddBillingNotificationsLocally,
  LoadNotifications,
  LoadNotificationsComplete,
  LoadNotificationUnreadCount,
  LoadNotificationUnreadCountComplete,
  ReadAllNotificationsComplete,
} from './notification.actions'
import { adapter, initialState, State } from './notification.state'
import * as R from 'ramda'
import { Action, createReducer, on } from '@ngrx/store'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'

export const reducer = createReducer(
  initialState,
  on(LoadNotifications, (state) => ({ ...state, isLoading: true })),
  on(LoadNotificationsComplete, (state, { notifications }) =>
    adapter.addMany(notifications, R.merge(state, { isLoaded: true, isLoading: false }))
  ),
  on(AddBillingNotificationsLocally, (state, { notifications }) => adapter.addMany(notifications, state)),
  on(LoadNotificationUnreadCount, (state) => ({ ...state, isUnreadCountLoading: true })),
  on(LoadNotificationUnreadCountComplete, (state, { count }) => ({
    ...state,
    unreadCount: count,
    isUnreadCountLoaded: true,
    isUnreadCountLoading: false,
  })),
  on(ReadAllNotificationsComplete, (state) => ({ ...state, unreadCount: 0 })),
  on(ActionFailed, (state) => ({ ...state, isLoading: false, isUnreadCountLoading: false }))
)

export function notificationReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
